export class Zone {
    ZoneID: number;
    ZoneName: string;
    ZoneDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}
